// extracted by mini-css-extract-plugin
module.exports = {"logicTable":"LogicDebugger_logicTable_qUlQ3","triggered":"LogicDebugger_triggered_3Nmaz"};